export default "__VITE_ASSET__CjHZdJ3a__"